import React, { JSX } from "react";

type ToastType = "info" | "success" | "warning" | "error" | "default";

const paths: Record<string, JSX.Element> = {
  success: <path d="M4.5 8.5 7 11l4.5-5" />,
  error: (
    <>
      <path d="M8 4.5v4.2" />
      <path d="M8 11.3h.01" />
    </>
  ),
  warning: (
    <>
      <path d="M8 4.8v4" />
      <path d="M8 11.2h.01" />
    </>
  ),
  info: (
    <>
      <path d="M8 7.4v4" />
      <path d="M8 4.9h.01" />
    </>
  )
};

/** Eigene Toast-Symbole: Glyph im weich eingefärbten Kreis statt gefüllter Vollfläche. */
export const toastIcon = ({ type }: { type: ToastType }): JSX.Element | false => {
  const variant = type === "default" ? "info" : type;
  const glyph = paths[variant];
  if (!glyph) return false;

  return (
    <span className={`toast-icon toast-icon--${variant}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.9}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden={true}>
        {glyph}
      </svg>
    </span>
  );
};
